<template>
  <v-select
      v-model="select"
      :items="countries"
      label="Select"
      item-text="name"
    >
      <template v-slot:item="slotProps" >
        <i :class="['mr-2', 'fi', slotProps.item.flag]"></i>
        {{slotProps.item.name}}
      </template>
     </v-select>
</template>

<script>
export default {
    data: () => ({
        select: null,
    countries: [
      {
        name: "Andorra",
        flag: "fi-af"
      },
   ],
    })
}
</script>

<style>

</style>